export default __webpack_public_path__ + "static/media/13.7c96fd65.pdf";